// Valores aceitos pelo backend em `type_oab` (TypeOabEnum).
export const TYPE_OAB_OPTIONS = [
  { value: 'ADVOGADO', label: 'Advogado' },
  { value: 'ESTAGIARIO', label: 'Estagiário' },
  { value: 'SUPLEMENTAR', label: 'Suplementar' },
];

const normalizeValue = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toUpperCase();

// Retorna o valor do enum quando bate com uma das opções; senão, string vazia.
export const resolveTypeOab = (value) => {
  const normalized = normalizeValue(value);
  return TYPE_OAB_OPTIONS.some((option) => option.value === normalized) ? normalized : '';
};

export const getTypeOabLabel = (value) => {
  const resolved = resolveTypeOab(value);
  return TYPE_OAB_OPTIONS.find((option) => option.value === resolved)?.label || '';
};
